var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"classification-banner",style:({ 'background-color': _vm.backgroundColor })},[_c('p',{staticClass:"classification-text",style:({ color: _vm.textColor })},[_vm._v(" Highest Possible Sensitivity of Information is "+_vm._s(_vm.marking)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }